export const getDocumentTypeIcon = (type, filledIcon = false) => {
    if (type === 'GIF') { return filledIcon ? 'gifFilled' : 'gif'; }
    if (type === 'MP4') { return filledIcon ? 'videoFilled' : 'video'; }
    if (type === 'PDF') { return filledIcon ? 'pdfFilled' : 'pdf'; }
    return filledIcon ? 'pictureFilled' : 'picture';
};

export const getAvailableDocumentFormats = () => ['pdf', 'png', 'jpeg', 'jpg', 'gif', 'mp4'];

export const getDocumentInputFileAcceptFormats = () => getAvailableDocumentFormats().map(format => `.${format}`).join();

export const documentFormatIsAvailable = fileFormat => getAvailableDocumentFormats().includes(fileFormat);

export const getDocumentContentUrl = (document, variant = 'original') => {
    const resource = document.asset_id
        ? `/documents/uploads/${document.asset_id}/content`
        : `/documents/${document.id}/content`;
    return `${resource}?variant=${variant}`;
};

export const getQRCodeDocumentContentUrl = (deviceId, documentId, variant = 'original') => (
    `/devices/${deviceId}/documents/${documentId}/content?variant=${variant}`
);
